<template>
  <v-container class="py-0">
    <material-wizard
      v-model="tab"
      class="mx-auto wizard-bulldozerr"
      :available-steps="tabsLiberadas"
      :wizzard-mixins-on="true"
      :tabs="tabs"
      max-width="1400"
      title="Adicionar Cálculo BulldozeRR"
      subtitle="Preencha as informações para gerar seu cálculo BulldozeRR."
      :loading="loading"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <!-- 1 ETAPA WIZZARD (INÍCIO) -->
      <v-tab-item eager>
        <informacoes-gerais
          ref="InformacoesGerais"
          @step-observer-nome="validInputsInfoGerais"
          @step-observer-empresa="validInputsInfoGerais"
          @step-observer-data-inicio="validInputsInfoGerais"
          @step-observer-data-final="validInputsInfoGerais"
        />
      </v-tab-item>
      <!-- 2 ETAPA WIZZARD (SELEÇÃO DE ETAPAS) -->
      <v-tab-item>
        <informacoes-selecao-etapas
          ref="InformacoesSelecaoEtapas"
          @step-observer-etapas="validInputsSelecaoEtapas"
          @change-etapas="etapasSelecionadas = $event"
        />
      </v-tab-item>
      <!-- 3 ETAPA WIZZARD (UPLOAD DE ARQUIVOS) -->
      <v-tab-item eager>
        <upload-files-bulldozerr
          ref="UploadFilesBulldozerr"
          :etapas-selecionadas="etapasSelecionadas"
          @step-observer-files="validInputsFiles"
        />
      </v-tab-item>
      <!-- 4 ETAPA WIZZARD (BANCO DE COMPRAS) -->
      <v-tab-item eager>
        <etapa-desativada
          v-if="!etapasSelecionadas.includes('banco_de_compras')"
          @intersect="validInputsInfoBancoCompras({ step: 'skip', complete: true })"
        />
        <informacoes-banco-compras
          v-else
          ref="InformacoesBancoCompras"
          @step-observer-fluxo-pagamento="validInputsInfoBancoCompras"
          @step-observer-valor-odc="validInputsInfoBancoCompras"
        />
      </v-tab-item>
      <!-- 5 ETAPA WIZZARD (BASE FISICA BDGD) -->
      <v-tab-item eager>
        <etapa-desativada v-if="!etapasSelecionadas.includes('base_fisica')" />
        <informacoes-bdgd v-else ref="InformacoesBdgd" />
      </v-tab-item>
      <!-- 6 ETAPA WIZZARD (AIS) -->
      <v-tab-item eager>
        <etapa-desativada v-if="!etapasSelecionadas.includes('analise_ais')" />
        <informacoes-ais v-else ref="InformacoesAis" />
      </v-tab-item>
      <!-- 7 ETAPA WIZZARD (BASE INCREMENTAL) -->
      <v-tab-item eager>
        <etapa-desativada v-if="!etapasSelecionadas.includes('base_incremental')" />
        <informacoes-base-incremental v-else ref="InformacoesBaseIncremental" />
      </v-tab-item>
      <!-- 8 ETAPA WIZZARD (OBRIGAÇÕES ESPECIAIS) -->
      <v-tab-item eager>
        <etapa-desativada
          v-if="!etapasSelecionadas.includes('obrigacoes_especiais')"
          @intersect="validInputsObrigacoesEspeciais({ step: 'skip', complete: true })"
        />
        <informacoes-obrigacoes-especiais
          v-else
          ref="InformacoesObrigacoesEspeciais"
          @step-observer-calculo-amortizacao="validInputsObrigacoesEspeciais"
        />
      </v-tab-item>
    </material-wizard>
  </v-container>
</template>

<script>
  import wizardMixins from '@/mixins/wizardMixins';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard.vue'),
      UploadFilesBulldozerr: () => import('@/components/bulldozerr/wizards/UploadFiles.vue'),
      InformacoesGerais: () => import('@/components/bulldozerr/wizards/InformacoesGerais.vue'),
      InformacoesBancoCompras: () => import('@/components/bulldozerr/wizards/InformacoesBancoCompras.vue'),
      InformacoesBdgd: () => import('@/components/bulldozerr/wizards/InformacoesBdgd.vue'),
      InformacoesAis: () => import('@/components/bulldozerr/wizards/InformacoesAis.vue'),
      InformacoesBaseIncremental: () => import('@/components/bulldozerr/wizards/InformacoesBaseIncremental.vue'),
      InformacoesObrigacoesEspeciais: () => import('@/components/bulldozerr/wizards/InformacoesObrigacoesEspeciais.vue'),
      InformacoesSelecaoEtapas: () => import('@/components/bulldozerr/wizards/InformacoesSelecaoEtapas.vue'),
      EtapaDesativada: () => import('@/components/bulldozerr/wizards/EtapaDesativada.vue')
    },

    mixins: [wizardMixins],

    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['save'],

    data() {
      return {
        tabs: [
          'Início',
          'Seleção de Etapas',
          'Upload de Arquivos',
          'Banco de Compras',
          'BDGD',
          'AIS',
          'Base Incremental',
          'Obrigações Especiais'
        ],
        tabsLiberadas: [],
        tab: 0,
        infosGeral: {
          nomeValid: false,
          empresaValid: false,
          dataInicioValid: false,
          dataFinalValid: false
        },
        infosEtapas: {
          etapasValid: false
        },
        infosBancoCompras: {
          valorOdcValid: false,
          fluxoPagamentoValid: false
        },
        infoObrigacoesEspeciais: {
          calculoAmortizacaoValid: false
        },
        etapasSelecionadas: []
      };
    },

    methods: {
      saveData() {
        const caminhoTmpUpload = this.$refs.UploadFilesBulldozerr.caminhoTmp;
        const informacoesGerais = this.$refs.InformacoesGerais.exportData();
        const informacoesSelecaoEtapas = this.$refs.InformacoesSelecaoEtapas.exportData();
        const informacoesBancoCompras = this.$refs.InformacoesBancoCompras?.exportData();
        const informacoesBdgd = this.$refs.InformacoesBdgd?.exportData();
        const informacoesAis = this.$refs.InformacoesAis?.exportData();
        const informacoesBaseIncremental = this.$refs.InformacoesBaseIncremental?.exportData();
        const informacoesObrigacoesEspeciais = this.$refs.InformacoesObrigacoesEspeciais?.exportData();

        return {
          informacoesGerais,
          informacoesSelecaoEtapas,
          informacoesBancoCompras,
          informacoesBdgd,
          informacoesAis,
          informacoesBaseIncremental,
          informacoesObrigacoesEspeciais,
          caminhoTmpUpload
        };
      },

      validInputsInfoGerais(event) {
        switch (event.step) {
          case 'nome':
            this.infosGeral.nomeValid = event.complete;
            break;
          case 'empresa':
            this.infosGeral.empresaValid = event.complete;
            break;
          case 'data-inicio':
            this.infosGeral.dataInicioValid = event.complete;
            break;
          case 'data-final':
            this.infosGeral.dataFinalValid = event.complete;
            break;
        }

        if (
          this.infosGeral.nomeValid &&
          this.infosGeral.empresaValid &&
          this.infosGeral.dataInicioValid &&
          this.infosGeral.dataFinalValid
        ) {
          this.updateStep({ step: 0, complete: true });
        } else {
          this.updateStep({ step: 0, complete: false });
        }
      },

      validInputsSelecaoEtapas(event) {
        switch (event.step) {
          case 'etapas':
            this.infosEtapas.etapasValid = event.complete;
            break;
        }

        if (this.infosEtapas.etapasValid) {
          this.updateStep({ step: 1, complete: true });
        } else {
          this.updateStep({ step: 1, complete: false });
        }
      },

      validInputsFiles(complete) {
        this.updateStep({ step: 2, complete });
      },

      validInputsInfoBancoCompras(event) {
        switch (event.step) {
          case 'valor-odc':
            this.infosBancoCompras.valorOdcValid = event.complete;
            break;
          case 'fluxo-pagamento':
            this.infosBancoCompras.fluxoPagamentoValid = event.complete;
            break;
          case 'skip':
            this.infosBancoCompras.valorOdcValid = event.complete;
            this.infosBancoCompras.fluxoPagamentoValid = event.complete;
            break;
        }

        if (this.infosBancoCompras.valorOdcValid && this.infosBancoCompras.fluxoPagamentoValid) {
          this.updateStep({ step: 3, complete: true });
          this.updateStep({ step: 4, complete: true });
          this.updateStep({ step: 5, complete: true });
          this.updateStep({ step: 6, complete: true });
        } else {
          this.updateStep({ step: 3, complete: false });
        }
      },

      validInputsObrigacoesEspeciais(event) {
        switch (event.step) {
          case 'calculo-amortizacao':
          case 'skip':
            this.infoObrigacoesEspeciais.calculoAmortizacaoValid = event.complete;
            break;
        }

        if (this.infoObrigacoesEspeciais.calculoAmortizacaoValid) {
          this.updateStep({ step: 7, complete: true });
        } else {
          this.updateStep({ step: 7, complete: false });
        }
      },

      updateStep({ step, complete }) {
        this.updateTabStatus({ step, complete });
      },

      save() {
        this.$emit('save');
      }
    }
  };
</script>

<style>
  .wizard-bulldozerr .v-tabs-bar__content {
    font-size: 10px !important;
  }
</style>
